import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const feeCalculationSelector = ({ feeCalculation }: ReducerState) => feeCalculation;
export const feeCalculationLoadingSelector = createSelector(
  feeCalculationSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
